import { Scope } from '@esg/esg-global-types';
import { GetScopesRequest, parseResolverResponse, ScopeFilters } from '@esg/syntiro-api-core';
import { apollo_client_v2 } from '../../App';
import { generateUuidV4 } from '../../util/uuid';
import { MetadataError } from '@ep/error-handling';
import { GET_SCOPES_QUERY } from '../queries/scope.query';
import { DocumentNode, FetchResult } from '@apollo/client';
import { FUNCTION_NO_DATA_FAILURE, FUNCTION_UNKNOWN_FAILURE } from '../../util/global_variables';

const SOURCE = 'scope.service.ts';

/**
 * Query all scopes.
 * @param {ScopeFilters} filters Filter parameters to use for scopes query.
 * @param {DocumentNode | undefined} query Optionally pass in specific query to use for desired scope fields.
 * @returns {Promise<Array<Scope>>}
 */
export const getScopes = async (
  filters: ScopeFilters = {},
  query: DocumentNode = GET_SCOPES_QUERY
): Promise<Array<Scope>> => {
  const input: GetScopesRequest['input'] = {
    metadata: {},
    filter: filters
  };

  return apollo_client_v2
    .query({
      variables: { input },
      query: query,
      fetchPolicy: 'no-cache'
    })
    .then((response: FetchResult) => {
      if (!response.data?.getScopes) {
        throw new Error(FUNCTION_NO_DATA_FAILURE('getScopes'));
      }
      const api_result: Array<Scope> | null | undefined = parseResolverResponse<Array<Scope>>(
        response.data.getScopes
      );
      return api_result ? api_result : [];
    })
    .catch((err: unknown) => {
      const tracking_id: string = generateUuidV4();
      throw new MetadataError(
        err instanceof Error ? err.message : FUNCTION_UNKNOWN_FAILURE(SOURCE, 'getScopes'),
        { filters, query },
        tracking_id
      );
    });
};
